var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "ah-icon-link",
      attrs: { href: _vm.product ? null : _vm.href },
      on: { click: _vm.handleClick }
    },
    [
      _c("img", {
        staticClass: "ah-icon-link-img",
        attrs: { src: _vm.icon.src, alt: _vm.icon.description }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "ah-icon-link-label" }, [
        _vm._v(_vm._s(_vm.label))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }